import styled from 'styled-components'

export const StyledForgotPasswordLink = styled.div``
